import { Col, Image } from "react-bootstrap"
import { NavLink } from "react-router-dom"
import { FaFacebook, FaGithub, FaLinkedinIn} from 'react-icons/fa';
import OpenNewTab from "../hooks/OpenNewTab";

const ProfileCard = (props) => {
    const {openInNewTab} = OpenNewTab();
  return (
    <Col lg={3} md={4} sm={12} className="text-center team mb-4 px-3">
    <div className="team-item rounded border overflow-hidden mb-2" data-aos="zoom-in">
        <div className="team-img position-relative py-3">
                <Image className="rounded-circle" src={"asset/img/team/" + props.img }
                alt="example"
                onError={(e) => {
                    e.target.src = 'asset/img/default/default.png' // some replacement image
                }}
                />
            <div className="team-social">
                <NavLink className="btn btn-sm mx-1"to="#" onClick={ (e) => openInNewTab(props.facebook)} ><FaFacebook /></NavLink>
                <NavLink className="btn btn-sm mx-1"to="#" onClick={ (e) => openInNewTab(props.github)}><FaGithub /></NavLink>
                <NavLink className="btn btn-sm mx-1"to="#" onClick={ (e) => openInNewTab(props.linkedIn)}><FaLinkedinIn /></NavLink>
            </div>
        </div>
        <div className="off-white py-4">
            <h6 className='fw-bold text-uppercase'>{props.name}</h6>
            <small className="m-0">{props.designation}</small>
        </div>
    </div>
  </Col>
  )
}

export default ProfileCard